import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="pt-20 min-h-screen flex items-center justify-center bg-paper-2 px-6">
      <div className="max-w-lg text-center border border-line bg-paper p-12" data-testid="payment-cancel">
        <span className="label text-brick">Checkout cancelled</span>
        <h1 className="font-serif text-5xl tracking-tight mt-4">No worries — nothing was charged.</h1>
        <p className="text-stone mt-4">Your print is still waiting whenever you're ready.</p>
        <Link to="/gallery/landscapes" data-testid="cancel-shop-btn" className="inline-block mt-10 label bg-ink text-paper px-8 py-4 hover:bg-brick transition-colors">Back to the gallery</Link>
      </div>
    </div>
  );
}
